import {Component, Inject, OnInit, AfterViewInit, Renderer2, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import {fuseAnimations} from '../../../../core/animations';
import {ActivatedRoute} from '@angular/router';
import {OrganizationsService} from '../../../../core/services/organizations.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {numberValidator , websiteValidator} from '../../../../core/validators/validators';
import * as _ from 'lodash';
import {CheckModalComponent} from '../../check-save-modal/check-modal';
import {Observable, Subscription} from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {NgxSpinnerService} from 'ngx-spinner';
import {FuseConfigService} from '../../../../core/services/config.service';
import {FuseDeleteDialogComponent} from '../../../../core/components/delete-dialog/delete-dialog.component';
import {ToastrService } from 'ngx-toastr';
import {DynamicDataOrgFormDialogComponent} from './setting-form/setting-form.component';
import {PrivacyFormDialogComponent} from './setting-dialog/setting-form.component';
import {PreviewFormDialogComponent} from './preview-dialog/setting-form.component';
import {FuncionTypeService} from '../../../../core/services/functionType.service';
import {WizzardDialogComponent} from './wizzard-dialog/setting-form.component';
import {EventDialogComponent} from './event-dialog/setting-form.component';
import { EventService } from '../../../../core/services/event.service';
import {Options} from 'ngx-qrcode-styling';

@Component({
    selector: 'organization-detail-page',
    templateUrl: './organization-detail.component.html',
    styleUrls: ['./organization-detail.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class OrganizationDetailComponent implements OnInit, OnDestroy {
  @ViewChild('qrContainer') qrContainer!: ElementRef;
  organization;
  copyUrl = 'https://www.pfefferstern.ch/';
  copyRegUrl = 'https://www.pfefferstern.ch/';
  copyUrlDef = 'https://www.pfefferstern.ch/';
  copyRegUrlDef = 'https://www.pfefferstern.ch/';

  embedUrl = 'https://www.pfefferstern.ch/organizationEvents?color=&data=';
  embedUrlDef = 'https://www.pfefferstern.ch/organizationEvents?color=&data=';

  public formGroup: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    countryId: new FormControl('', Validators.required),
    cityId: new FormControl('', Validators.required),
    cityLocation: new FormControl('', Validators.required),
    lang: new FormControl('', Validators.required),
    organizationTypeId: new FormControl('', Validators.required),
    address: new FormControl(''),
    postcode: new FormControl('', [numberValidator]),
    website: new FormControl('', [websiteValidator]),
    phone: new FormControl(''),
    whatsapp: new FormControl({value: '', disabled: true}),
    isTest: new FormControl({value: '', disabled: true}),
    allowCompetency: new FormControl({value: '', disabled: true}),
    allowTimeAndBudget: new FormControl({value: '', disabled: true}),
    allowGuestEvent: new FormControl('')
  });
  public languages = [ {label: 'English' , value: 'en'} , {label: 'Deutsch' , value: 'de'}, {label: 'Français' , value: 'fr'} ];

  public img;
  public uploadedImg = null;
  public countries = [];
  public cities = [];
  public types = [];
  public defaultForm;
  public defaultImg;
  public returnBack;
  public logo;
  isOrganizer = false;
  systemDynamicOrgData = [];
  systemDynamicData = [];
  orgId;
  dialogRef: any;
  adminTypes = [];
  adminRates = [];
  edit = false;
  newRates = {};
  ratesForSend = {};
  public subscription = new Subscription();
  public config: Options = {
    width: 250,
    height: 250,
    margin: 5,
    backgroundOptions: {
      color: '#ffffff',
    }
  };

  constructor (private route: ActivatedRoute ,
               private organizationService: OrganizationsService ,
               private router: Router , public dialog: MatDialog , public snackBar: MatSnackBar ,
               public translate: TranslateService , private spinner: NgxSpinnerService ,
               private fuseConfig: FuseConfigService , public toastr: ToastrService  , private functionService: FuncionTypeService,
               public eventService: EventService) {
    this.fuseConfig.projectSettings.subscribe((res: any) => {
      if (res) {
        this.copyUrl = res.websiteLink;
        this.copyRegUrl = res.websiteLink;
        this.copyUrlDef = res.websiteLink;
        this.copyRegUrlDef = res.websiteLink;
        this.embedUrl = res.websiteLink + 'organizationEvents?color=&data=';
        this.embedUrlDef = res.websiteLink + 'organizationEvents?color=&data=';
      }
    });
    const id = this.route.snapshot.queryParamMap.get('id');
    this.orgId = id;
    this.getPrivacyData(id);
    this.organizationService.getOrganizationById(id).subscribe((data: any) => {
      if (data.logo) {
        this.img = data.logo;
        this.logo = data.logo;
        this.defaultImg = this.img;
      }
      this.organization = data;
      let _cities = this.organization.cityId.toString().split(',');
      if (_cities.length === 1) {
        this.copyUrl = this.copyUrlDef + this.organization.country.flag + '/' +
          this.organization.city.code + '/' + this.organization.id;
        let orgId: any = +this.organization.id * 12345654321;
        orgId = orgId.toString(16);
        this.embedUrl = this.embedUrlDef + orgId;
        this.copyRegUrl = this.copyRegUrlDef + this.organization.country.flag + '/' +
          this.organization.city.code + '/' + this.organization.id + '?reg=1';
      } else if (_cities.length >= 2){
        this.copyUrl = this.copyUrlDef + this.organization.country.flag + '/0/' + this.organization.id;
        this.copyRegUrl = '';
      }

      this.organizationService.getCountry().subscribe((result: any) => {
        this.countries = result;
        this.organizationService.getOrganizationType().subscribe((typeResult: any) => {
          this.types = typeResult;
          this.initForm(this.organization);
          setTimeout(() => {
            this.spinner.hide();
          } , 500);
        });
      });
    });

    this.functionService.getFunctionTypeDropDown().subscribe((res: any) => {
      this.adminTypes = res;
      this.adminTypes.map((item: any) => {
        this.newRates[ item.id ] = {};
        this.newRates[ item.id ][ 'preparation' ] = 0;
        this.newRates[ item.id ][ 'follow-up' ] = 0;
        this.newRates[ item.id ][ 'execution' ] = 0;
      });
    });

    this.getRates();
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  copyUrlFunc() {
    let copyText: any = document.getElementById('copyUrl');
    copyText.select();
    document.execCommand('copy');
    this.snackBar.open('Copied' , '' , {duration: 2500});
  }

  copyCodeFunc() {
    let copyText: any = document.getElementById('copyEmbedUrl');
    copyText.select();
    document.execCommand('copy');
    this.snackBar.open('Copied' , '' , {duration: 2500});
  }

  copyRegUrlFunc() {
    let copyText: any = document.getElementById('copyRegUrl');
    copyText.select();
    document.execCommand('copy');
    this.snackBar.open('Copied' , '' , {duration: 2500});
  }

  getRates () {
    this.organizationService.getAdminRates(this.orgId).subscribe((res: any) => {
      if (res) {
        for (let i = 0; i < res.length; i++) {
          if (!this.adminRates[ res[ i ][ 'functionId' ] ]) {
            this.adminRates[ res[ i ][ 'functionId' ] ] = {};
          }
          this.adminRates[ res[ i ][ 'functionId' ] ][ res[ i ][ 'type' ] ] = res[ i ][ 'rate' ];
          if (!this.newRates[ res[ i ][ 'functionId' ] ]) {
            this.newRates[ res[ i ][ 'functionId' ] ] = {};
          }
          this.newRates[ res[ i ][ 'functionId' ] ][ res[ i ][ 'type' ] ] = res[ i ][ 'rate' ];
        }
      }
    });
  }

  saveRates () {
    let arrayOfRates = [];
    const keys = Object.keys(this.ratesForSend);
    for (const key of keys) {
      const keys1 = Object.keys(this.ratesForSend[ key ]);
      for (const key1 of keys1) {
        arrayOfRates.push({
          functionId: key ,
          organizationId: this.orgId ,
          type: key1 ,
          rate: this.ratesForSend[ key ][ key1 ]
        });
      }
    }
    this.organizationService.updateAdminRates(arrayOfRates).subscribe((res) => {
      this.ratesForSend = {};
      this.getRates();
    });
  }

  changeRates (data) {
    if (!this.ratesForSend[ data.id ]) {
      this.ratesForSend[ data.id ] = {};
    }
    if (!data.value) {
      this.ratesForSend[ data.id ][ data.type ] = 0;
    } else {
      this.ratesForSend[ data.id ][ data.type ] = data.value;
    }

  }

  ngOnInit () {
    this.spinner.show();
    this.initForm({});
    this.getPrivacyData(this.orgId);
    this.subscription.add(this.translate.onLangChange.subscribe(res => {
      this.getPrivacyData(this.orgId);
    }));
  }

  ngOnDestroy () {
    this.subscription.unsubscribe();
  }

  activeData (even , i) {
    this.spinner.show();
    this.systemDynamicData[ i ].active = true;
    this.organizationService.setDynamicOrgData(this.systemDynamicData[ i ] , this.orgId).subscribe((res) => {
      if (res) {
        this.getPrivacyData(this.orgId);
        this.spinner.hide();
      }
    });
  }

  newType () {
    this.dialogRef = this.dialog.open(DynamicDataOrgFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '70vw' ,
      data: {
        action: 'new'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response: FormGroup) => {
        if (response) {
          const data = response.value;
          data.organizationId = this.orgId;
          this.organizationService.addDynamicDataOrg(data).subscribe((res) => {
            if (res) {
              this.snackBar.open('Dynamic data added.' , '' , {duration: 2500});
              this.getPrivacyData(this.orgId);
            }
          } , error => {
            this.snackBar.open('Add failed.' , '' , {duration: 2500});
          });
        }
      });

  }

  changePrivacy () {
    this.dialogRef = this.dialog.open(PrivacyFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '70vw' ,
      data: {
        privacy: this.organization.privacy
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response: any) => {
        if (response) {
          const data = {id: null , privacy: response};
          data.id = this.orgId;
          this.organizationService.addOrganization(data).subscribe((res: any) => {
            if (res) {
              this.snackBar.open('Privacy data added.' , '' , {duration: 2500});
              this.organization.privacy = res.privacy;
            }
          } , error => {
            this.snackBar.open('Add failed.' , '' , {duration: 2500});
          });
        }
      });

  }

  openWizzard () {
    this.dialogRef = this.dialog.open(WizzardDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '70vw' ,
      data: {
        id: this.orgId
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response: any) => {

      });

  }

  previewPrivacy () {
    this.dialogRef = this.dialog.open(PreviewFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '70vw' ,
      data: {
        privacy: this.organization.privacy ,
        rules: this.systemDynamicOrgData ,
      }
    });
  }

  editType (type , ready) {
    this.dialogRef = this.dialog.open(DynamicDataOrgFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '70vw' ,
      data: {
        type: type ,
        action: 'edit' ,
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        const actionType: string = response[ 0 ];
        const data = response[ 1 ].value;
        data.id = type.id;
        switch (actionType) {
          /**
           * Save
           */
          case 'save':
            if (ready) {
              data.key = data.id + type.key;
              data.dynamicDataId = data.id;
              data.id = null;
              data.organizationId = this.orgId;
              data.active = false;
              this.organizationService.addDynamicDataOrg(data).subscribe((res) => {
                if (res) {
                  this.snackBar.open('Dynamic data  updated.' , '' , {duration: 2500});
                  this.getPrivacyData(this.orgId);
                }
              } , error => {
                this.snackBar.open('Update failed.' , '' , {duration: 2500});
              });
              break;
            } else {
              this.organizationService.addDynamicDataOrg(data).subscribe((res) => {
                if (res) {
                  this.snackBar.open('Dynamic data  updated.' , '' , {duration: 2500});
                  this.getPrivacyData(this.orgId);
                }
              } , error => {
                this.snackBar.open('Update failed.' , '' , {duration: 2500});
              });
              break;
            }
          /**
           * Delete
           */
          case 'delete':
            this.organizationService.deleteDynamicDataOrg(type.id).subscribe((res) => {
              if (res) {
                this.snackBar.open('Dynamic data  deleted.' , '' , {duration: 2500});
                this.getPrivacyData(this.orgId);
              }
            } , error => {
              this.snackBar.open('Delete failed.' , '' , {duration: 2500});
            });

            break;
        }
      });
  }


  changeStatus (item) {
    this.spinner.show();
    this.organizationService.changeDynamicOrgData(item).subscribe((res) => {
      if (res) {
        this.getPrivacyData(this.orgId);
        this.spinner.hide();
      }
    });
  }

  getPrivacyData (id) {
    const lang = this.translate.currentLang;
    this.organizationService.getDynamicDataOrg(id).subscribe((res: any) => {
      this.systemDynamicOrgData = res;
      this.organizationService.getDynamicData(lang).subscribe((result: any) => {
        this.systemDynamicData = [];
        for (let i = 0; i < result.length; i++) {
          if (!this.systemDynamicOrgData.find(item => item.dynamicDataId === result[ i ].id)) {
            this.systemDynamicData.push(result[ i ]);
          }
        }
      });
    });
  }

  initForm (data) {
    // this.formGroup.get('whatsapp').valueChanges.subscribe((res) => {
    //   const inputControlAccountSid = this.formService.findById('accountSid' , this.formModel) as DynamicInputModel;
    //   const inputControlAuthToken = this.formService.findById('authToken' , this.formModel) as DynamicInputModel;
    //   if (res) {
    //     inputControlAccountSid.hidden = false;
    //     inputControlAuthToken.hidden = false;
    //     inputControlAccountSid.required = true;
    //     inputControlAuthToken.required = true;
    //     this.formGroup.controls.accountSid.setValidators([Validators.required]);
    //     this.formGroup.controls.authToken.setValidators([Validators.required]);
    //   } else {
    //     inputControlAccountSid.hidden = true;
    //     inputControlAuthToken.hidden = true;
    //     inputControlAccountSid.required = false;
    //     inputControlAuthToken.required = false;
    //     this.formGroup.controls.accountSid.setValidators([]);
    //     this.formGroup.controls.authToken.setValidators([]);
    //     this.formGroup.patchValue({accountSid: null, authToken: null});
    //   }
    // });
    this.formGroup.get('countryId').valueChanges.subscribe((res) => {
      this.organizationService.getCity(res).subscribe((result: any) => {
        this.cities = result;
        if (data && data.cityId) {
          let cities = data.cityId.toString().split(',');
          cities = cities.map(el => +el);
          this.formGroup.patchValue({cityId: cities});
        }
      });
    });
    if (data && data.cityId && data.cityId.toString().length) {
      let arr  = data.cityId.toString().split(',');
      arr = arr.map(x => +x);
      this.formGroup.patchValue({cityId: arr});
    }
    delete data.cityId;
    this.formGroup.patchValue(data);
    if (this.countries.length === 1) {
      this.formGroup.patchValue({countryId: this.countries[ 0 ].id});
    }
    this.defaultForm = this.formGroup.value;
    this.subscription.add(this.fuseConfig.role.subscribe(res => {
      if (res && res === 'organisationAdmin') {
        this.isOrganizer = true;
      } else {
        this.isOrganizer = false;
      }
      if (res && (res === 'superAdmin' || res === 'subCountryAdmin' )) {
        const inputControlWhatsapp = this.formGroup.get('whatsapp');
        inputControlWhatsapp.enable();
        const inputControlIsTest = this.formGroup.get('isTest');
        inputControlIsTest.enable();
      }
      if (res && res === 'superAdmin') {
        const inputControlAllowCompetency = this.formGroup.get('allowCompetency');
        inputControlAllowCompetency.enable();
        const inputControlAllowTimeAndBudget = this.formGroup.get('allowTimeAndBudget');
        inputControlAllowTimeAndBudget.enable();
      }
    }));
  }

  openEvent() {
    const dialogRef = this.dialog.open(EventDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '99vw' ,
      data: {oldID: this.organization.oldID, id: this.orgId}
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }


  updateOrganization (returnToOrg) {
    const data = this.formGroup.value;
    data.file = this.uploadedImg;
    data.id = this.organization.id;
    this.organizationService.addOrganization(data).subscribe((res) => {
      this.saveRates();
      this.returnBack = returnToOrg;
      if (res && returnToOrg) {
        this.organizationService.updateSuccess = true;
        this.toastr.success('Organization updated' , 'Success!');
        this.router.navigate([ './pages/organization' ]);
      }
    });
  }

  deleteOrganization () {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.organizationService.deleteOrganization(this.organization.id).subscribe((res) => {
          this.toastr.success('Organization deleted' , 'Success!');
          this.router.navigate([ './pages/organization' ]);
        });
      }
    });
  }

  canDeactivate (): Observable<boolean> | boolean {
    return this.goBack();
  }

  goBack (): any {
    let dialogRef;
    if (!this.compareForms() && !this.returnBack) {
      dialogRef = this.dialog.open(CheckModalComponent , {
        panelClass: 'unsave-form-dialog' ,
        width: '70vw' ,
      });

      return dialogRef.afterClosed().toPromise().then((result: any) => {
        if (result === 'leave') {
          return true;
        } else if (result === 'save') {
          if (this.formGroup.valid) {
            this.updateOrganization(false);
            return true;
          } else {
            this.snackBar.open('Please fill forms correctly' , '' , {duration: 2500});
            return false;
          }
        }
      });
    } else {
      return true;
    }
  }

  compareForms () {
    return _.isEqual(this.formGroup.value , this.defaultForm) && (this.defaultImg === this.img);
  }

  setImg (img) {
    this.uploadedImg = img;
  }

  addAdmin () {
    this.router.navigate([ '/pages/user/new' ] , {
      queryParams: {
        country: this.organization.countryId ,
        subCountry: this.organization.cityId ,
        orgId: this.organization.id
      }
    });
  }

  showAdmins () {
    this.router.navigate([ '/pages/users' ] , {
      queryParams: {
        country: this.organization.countryId ,
        subCountry: this.organization.cityId ? this.organization.cityId : this.organization?.city?.id,
        orgId: this.organization.id
      }
    });
  }

  editRates() {
    this.adminTypes.forEach((el) => {
      if (this.adminRates && this.adminRates[el.id] && this.adminRates[el.id]['preparation']) {
        this.changeRates({type: 'preparation', id: el.id, value: this.adminRates[el.id]['preparation']});
      } else if (this.newRates && this.newRates[el.id] && this.newRates[el.id]['preparation']) {
        this.changeRates({type: 'preparation', id: el.id, value: this.newRates[el.id]['preparation']});
      }
    });
  }

  downloadQRcode() {
    const canvas = this.qrContainer.nativeElement.querySelector('canvas') as HTMLCanvasElement;

    if (!canvas) {
      console.error('Canvas не знайдено! Перевірте, чи QR код вже згенеровано.');
      return;
    }

    const imageSrc = canvas.toDataURL('image/png');

    const link = document.createElement('a');
    link.href = imageSrc;
    link.download = 'qr-code.png';

    link.click();
    link.remove();
  }
}
